module.exports = __webpack_public_path__ + "img/new-ssl.b7bf873e.png";